/* Raw Bean click-id capture -> cart attributes (RAW-110, 2026-06-10).
   Persists gclid/wbraid/gbraid from ad landings for 90 days (Google click
   window) and stamps them onto any non-empty cart so they reach
   order.note_attributes -> Recharge subscription -> every rebill order ->
   recharge_ads_oci_bridge.py. Fails silent by design; never blocks the page. */
(function () {
  var KEY = '_rb_click_ids', NOW = Date.now(), TTL = 90 * 864e5;
  function stored() {
    try {
      var d = JSON.parse(localStorage.getItem(KEY) || 'null');
      return d && (NOW - d.ts) < TTL ? d : null;
    } catch (e) { return null; }
  }
  try {
    var p = new URLSearchParams(location.search), fresh = {};
    ['gclid', 'wbraid', 'gbraid'].forEach(function (k) {
      var v = p.get(k); if (v) fresh[k] = v;
    });
    if (Object.keys(fresh).length) {
      fresh.ts = NOW;
      try { localStorage.setItem(KEY, JSON.stringify(fresh)); } catch (e) {}
    }
    var ids = stored();
    if (!ids) return;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.item_count) return; /* only stamp real carts */
        var want = {}, have = cart.attributes || {};
        if (ids.gclid)  want._rb_gclid  = ids.gclid;
        if (ids.wbraid) want._rb_wbraid = ids.wbraid;
        if (ids.gbraid) want._rb_gbraid = ids.gbraid;
        var dirty = Object.keys(want).some(function (k) { return have[k] !== want[k]; });
        if (!dirty) return;
        return fetch('/cart/update.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: want })
        });
      })
      .catch(function () {});
  } catch (e) {}
})();
